"use client";

import React from "react";
// import { Button, useDisclosure } from "@heroui/react";
// import { Icon } from "@iconify/react";
// import { useTranslation } from "react-i18next";

// import { SidebarDrawer } from "./SidebarDrawer";
// import { ChatHistoryComponent } from "./ChatHistory";

// import { useWebuildAPIClient } from "@/providers/WeBuildClientProvider";
// import { useChatStore } from "@/stores/ChatStore";
// import { useChatHistoryStore } from "@/stores/ChatHistoryStore";
// import { useAuth } from "@webuild-ai/react-auth";

export const SidebarWithChatHistory = (props: {
  children?: React.ReactNode;
  header?: React.ReactNode;
  title?: string;
  subTitle?: string;
  classNames?: Record<string, string>;
}) => {
  // const { newChat } = useChatStore();
  // const { fetchChatHistory } = useChatHistoryStore();
  // const { user } = useAuth();
  // const { adminClient } = useWebuildAPIClient();
  const { children } = props;
  // const { isOpen, onOpenChange } = useDisclosure();
  // const [isShowHistory, setIsShowHistory] = useState<boolean>(false);
  // const { t } = useTranslation();

  // Removed automatic newChat() on mount - this was clearing the chat unexpectedly
  // useEffect(() => {
  //   newChat();
  // }, []);

  // const handleNewChat = () => {
  //   newChat();
  //   setIsShowHistory(false);

  //   // Fetch chat history again to refresh the list
  //   if (adminClient && user?.id) {
  //     fetchChatHistory(user.id, adminClient);
  //   }
  // };

  // const handleSelectChat = async (chatHistoryId: string) => {
  //   if (!adminClient) return;
  //   await load(adminClient, chatHistoryId);
  // };

  // const content = (
  //   <div
  //     className={`relative flex flex-1 flex-col p-0 pt-0 h-full ${isShowHistory ? "w-72" : "w-12"}`}
  //     data-id={`sidebar-content-${isShowHistory}`}
  //   >
  //     <div className="flex-shrink-0" />
  //     <div className="relative flex items-center pt-1">
  //       {isShowHistory && (
  //         <div className="flex-1 flex justify-center">
  //           <Button
  //             className="bg-default-foreground text-default-50 h-[36px] px-2 text-sm"
  //             data-id="new-chat-button"
  //             size="sm"
  //             startContent={
  //               <Icon className="text-default-50" icon="solar:chat-round-dots-linear" width={20} />
  //             }
  //             onPress={handleNewChat}
  //           >
  //             {t("New Chat")}
  //           </Button>
  //         </div>
  //       )}

  //       <Button
  //         isIconOnly
  //         className={`${isShowHistory ? "absolute right-0" : "ml-auto"}`}
  //         data-id={`toggle-history-button-${isShowHistory}`}
  //         variant="ghost"
  //         onPress={() => setIsShowHistory(!isShowHistory)}
  //       >
  //         <Icon
  //           icon={
  //             isShowHistory
  //               ? "solar:round-alt-arrow-left-linear"
  //               : "solar:round-alt-arrow-right-linear"
  //           }
  //           width={24}
  //         />
  //       </Button>
  //     </div>
  //     <ChatHistoryComponent
  //       isShowHistory={isShowHistory}
  //       // onNewChat={handleNewChat}
  //       onSelectChat={handleSelectChat}
  //     />
  //   </div>
  // );

  return (
    <div className="flex h-screen w-full py-4" data-id="sidebar-with-chat-history">
      {/* <SidebarDrawer
        className="h-full flex-none rounded-[14px]"
        data-id="sidebar-drawer"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      >
        {content}
      </SidebarDrawer> */}
      <div className="flex w-full flex-col" data-id="main-content">
        <main className="flex h-full" data-id="chat-main">
          <div
            className="flex h-full w-full flex-col rounded-none rounded-b-medium"
            data-id="chat-container"
          >
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
